import React from "react";
import { Alert, Snackbar } from "@mui/material";

export type AppSnackbarPayload = {
  message: string;
  severity?: "error" | "warning" | "info" | "success";
};

type Listener = (p: AppSnackbarPayload) => void;

let listeners: Listener[] = [];

export function showAppSnackbar(payload: AppSnackbarPayload) {
  const p: AppSnackbarPayload = {
    severity: payload.severity || "error",
    message: payload.message,
  };
  listeners.forEach((fn) => fn(p));
}

export const AppSnackbarHost: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [payload, setPayload] = React.useState<AppSnackbarPayload>({
    message: "",
    severity: "error",
  });

  React.useEffect(() => {
    const handler: Listener = (p) => {
      setPayload(p);
      setOpen(true);
    };
    listeners.push(handler);
    return () => {
      listeners = listeners.filter((l) => l !== handler);
    };
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={() => setOpen(false)}
        severity={payload.severity}
        variant="filled"
        sx={{ bgcolor: payload.severity === "warning" ? "#ff9800" : undefined }}
      >
        {payload.message}
      </Alert>
    </Snackbar>
  );
};

export default AppSnackbarHost;
